import { createComponent } from '@carvana/merch-components';
import React from 'react';

export default createComponent<React.HTMLProps<HTMLButtonElement>>('button', {
  className:
    'bg-transparent text-blue-2 hover:text-blue-3 u:inline u:w-fit u:p-0 u:text-left u:[font-size:inherit] u:[font-weight:inherit]'
});
